import FooterButton from './FooterButton';

export default FooterButton;
